import { render, staticRenderFns } from "./protocolosServicios.vue?vue&type=template&id=52234690&"
import script from "./protocolosServicios.vue?vue&type=script&lang=js&"
export * from "./protocolosServicios.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports